import { render, staticRenderFns } from "./TableTicketsComplex.vue?vue&type=template&id=ae0c8260&scoped=true"
import script from "./TableTicketsComplex.vue?vue&type=script&lang=js"
export * from "./TableTicketsComplex.vue?vue&type=script&lang=js"
import style0 from "./TableTicketsComplex.vue?vue&type=style&index=0&id=ae0c8260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0c8260",
  null
  
)

export default component.exports